import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import PersonnelIndexView from 'components/personnel/PersonnelIndexView';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <PersonnelIndexView {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
